import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import Loader from '../../Loader'

function LeadTypeConversionView({ leadTypeConversion}) {
    const data = [
        { label: 'From', data: leadTypeConversion.convertFrom ? leadTypeConversion.convertFrom.name : "" },
        { label: 'Duration (days)', data: leadTypeConversion.convertDuration },
        { label: 'To', data: leadTypeConversion.convertTo ? leadTypeConversion.convertTo.name : "" }
    ]
    return (
        <Grid container>
            {leadTypeConversion ? (
                <Grid item lg={12} container spacing={3}>
                    {data.map((item, index) => (
                        <Grid item lg={4} key={index}>
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
                                <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Loader />
            )}
        </Grid>
    )
}

export default LeadTypeConversionView
